import { generateTypes } from '../../utils/HttpReducerHelper';

export const fundingSearchOffers = generateTypes('FUNDING_SEARCH_OFFERS', 'OFFERS');
export const fundingSearchOffer = generateTypes('FUNDING_SEARCH_OFFER', 'OFFER');
export const fundingSearchMatch = generateTypes('FUNDING_SEARCH_MATCH', 'MATCH');
